import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from './../../../../themes/default';
import { IconButton } from './../../../../themes/button'
import { CloseIcon } from './../../../../themes/icons'
import { Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from './../../../../themes/dialog';

const styles = theme => ({
  content: { paddingTop: theme.spacing.unit * 3 },
  header:  {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
  actions: {
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2
  }
});

const Modal = ({ children, classes, status, title, actions, handleCancel, ...rest}) => {

  return (
    <Dialog
        fullWidth
        open={ status }
        onClose={ handleCancel } { ...rest }>

      { title && (
        <DialogTitle disableTypography className={ classes.header }>
          <Typography component="p" variant="h6">
            { title }
          </Typography>
          <IconButton aria-label="Close" className={ classes.closeButton } onClick={ handleCancel }>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      )}

      <DialogContent className={ classes.content }>
        <DialogContentText component="div">
          { children }
        </DialogContentText>
      </DialogContent>

      { actions && (
        <DialogActions className={ classes.actions }>
          <div style={{ 'width': '100%' }}>
            { actions }
          </div>
        </DialogActions>
      )}

    </Dialog>
  )

}

Modal.propTypes = {
  children:  PropTypes.node.isRequired,
  status:  PropTypes.bool.isRequired
};

export default withStyles(styles)(Modal);
